<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import "./actus"
</style>


<script>

    import $ from "jquery";
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {

        components: {
            swiper,
            swiperSlide
        },
        mounted () {
            if ( !this.isMobile ) {
                this.initArticlesTags();
            }
        },

        data () {
            return {
                articlesTagsOptions: [],
                articlesTag: "all",
                isMobile: ( $(window).width() <= 1000 ),
                swiperOptions : {
                    spaceBetween: 50,
                    pagination: {
                        el: '.swiper-pagination',
                        dynamicBullets: true,
                    }
                },
            }
        },

        watch: {
            articlesTag: function() {
                this.showArticles();
            },
        },

        methods: {

            initArticlesTags: function() {
                let articles = $('.actus__item');

                articles.each((index, obj) => {
                    let $obj = $(obj);
                    let classes = _($obj.attr('class').split(' '))
                            .filter( item => item.indexOf('tag-') > -1 )
                            .map ( item => item.replace('tag-', ''))
                            .value();
                    if (this.articlesTagsOptions.length > 0) {
                      this.articlesTagsOptions = _.union(this.articlesTagsOptions, classes);
                    }
                })

                this.showArticles();
            },

            showArticles() {
                let $articles = $('.actus__item');
                $articles.hide().removeClass('first');

                let nb = 0;
                let id = 0;

                _.each($articles, (article, id) => {
                    let $article = $(article);

                    while (id > 10) {
                        id -= 10;
                    }
                    if ( (id % 10) == 0 || (id % 6) == 0) {
                        $article.addClass('first');
                        if ( (id / 6) % 2 != 0 ) {
                            $article.addClass('last');
                        }
                    }

                    if ( nb < 5 ) {
                        if ( this._showArticle($article, nb) )
                            nb++;
                    }

                }, id += 1);

                let _foo = () => {
                    if ( $articles.filter(':visible').length > 5 && $articles.filter(':visible').length % 5 !== 0) {
                        let articles = $articles.filter(':visible');
                        $(articles[articles.length - 1]).hide();
                        setTimeout(_foo, 10);
                    }
                };
                _foo();


            },

            _showArticle($article) {
                let flag = false;

                if ( this.articlesTag && this.articlesTag !== "all" ) {
                    if ( $article.hasClass('tag-' + this.articlesTag) ) {
                        $article.show();
                        flag = true;
                    }
                } else {
                    $article.show();
                    flag = true;
                }

                return flag;
            },

            scrollToArticles() {
                $('html, body').animate({
                    scrollTop: $(".actus").offset().top - 50
                });
            }

        }

    }


</script>
